document.addEventListener('DOMContentLoaded', function () {
  const colorToCodeMap = {
    'Extra Flint': 'BR',
    'Flint': 'FL',
    'Champagne Green': 'CG',
    'Dead Leaf Green': 'DL',
    'Green Auv': 'BR',
    'Amber': 'AM',
    'Antique Green': 'AT',
    'Brown': 'BR',
    'Emerald Green': 'EG',
    'Nordic Blue': 'NB',
    'Georgia Green': 'GG',
    'Cobalt Blue': 'CB',
    'Charcoal': 'CH',
    'Horizon Blue': 'HB',
    'Mist Green': 'MG',
    'Slate Blue': 'SB',
    'Spring Green': 'SG',
    'Sapphire Blue': 'SP',
    'Orchid': 'OR',
    'Frost Blue': 'FB',
    'Arctic Blue': 'BR',
    'Aqua Blue': 'BR',
    'Transition': 'BR',
    'Smoke': 'SM'
  };

  // Function to bind 3D click handlers
  function bind3DButtons() {
    const buttons = document.querySelectorAll('.open-3d-modal-btn');

    buttons.forEach(button => {
      // Avoid rebinding
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', function (e) {
        e.preventDefault(); // this is crucial to stop the default anchor behavior

        const bic = this.dataset.bic?.trim();
        const color = this.dataset.color?.trim();
        const code = colorToCodeMap[color];

        if (!bic || !code) {
          console.warn('Missing BIC or color code for 3D modal.');
          return;
        }

        const iframe = document.querySelector('#modal-3d iframe');
        const modal = document.getElementById('modal-3d');
        const baseURL = window.agpConfig?.viewerBaseURL;

        const newSrc = `${baseURL}/${bic}_${code}_XR/${bic}_${code}_XR.html`;

        iframe.src = '';
        setTimeout(() => {
          iframe.src = newSrc;
          modal.classList.remove('hidden');
        }, 50);
      });
    });
  }

  // Initial bind
  bind3DButtons();

  // Re-bind after filters change DOM (Shopify Search & Discovery app uses DOM swaps)
  const observer = new MutationObserver(() => {
    bind3DButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Close modal logic
  const closeBtn = document.getElementById('close-3d-modal');
  const modal = document.getElementById('modal-3d');

  if (closeBtn && modal) {
    closeBtn.addEventListener('click', () => modal.classList.add('hidden'));
    modal.addEventListener('click', (e) => {
      if (e.target === modal) modal.classList.add('hidden');
    });
  }
});


